import React from 'react';
import styles from './DropdownFilter.module.css';
import DropdownFilterHeader from './DropdownFilter.Header';
import DropdownFilterCheckboxList from './DropdownFilter.CheckboxList';
import DropdownFilterFooter from './DropdownFilter.Footer';
import SlidingDrawer from '../SlidingDrawer/SlidingDrawer';
import { FloatingPortal } from '@floating-ui/react';
import { ContentProps } from './types';

const DropdownFilterContent: React.FC<ContentProps> = ({
  ui: { isMobile, setFloating, floatingStyles, floatingProps, itemProps },
  data: { heading, name, options, selectedValues, listRef },
  state: { isOpen, loading, error, activeIndex },
  callbacks: { onCheckboxChange, onClear, onClose },
}) => {
  const content = (
    <>
      <DropdownFilterHeader
        heading={heading}
        isMobile={isMobile}
        onClose={onClose}
      />
      <DropdownFilterCheckboxList
        name={name}
        options={options}
        selectedValues={selectedValues}
        onCheckboxChange={onCheckboxChange}
        loading={loading}
        error={error}
        listRef={listRef}
        itemProps={itemProps}
        activeIndex={activeIndex}
      />
      <DropdownFilterFooter
        hasSelectedValues={selectedValues.length > 0}
        isMobile={isMobile}
        onClear={onClear}
        onClose={onClose}
      />
    </>
  );

  if (isMobile) {
    return (
      <SlidingDrawer isOpen={isOpen} onClose={onClose}>
        {content}
      </SlidingDrawer>
    );
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (typeof floatingProps.onKeyDown === 'function') {
      floatingProps.onKeyDown(event);
    }
    switch (event.key) {
      case 'Escape':
        handleEscapeKey(event);
        break;
      case 'Tab':
        handleTabKey(event);
        break;
    }
  };

  const handleEscapeKey = (event: React.KeyboardEvent) => {
    event.preventDefault();
    onClose();
  };

  const handleTabKey = (event: React.KeyboardEvent<HTMLDivElement>) => {
    const container = event.currentTarget;
    const focusableElements = Array.from(
      container.querySelectorAll(
        'button, input, [tabindex]:not([tabindex="-1"])'
      )
    ) as HTMLElement[];

    if (focusableElements.length === 0) {
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    const isTabForward = !event.shiftKey;
    const isTabBackward = event.shiftKey;
    const activeElement = document.activeElement;

    if (isTabForward && activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    } else if (isTabBackward && activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    }
  };
  return (
    <FloatingPortal>
      {isOpen && (
        <div
          className={styles.dropdownContent}
          ref={setFloating}
          style={floatingStyles}
          {...floatingProps}
          onKeyDown={handleKeyDown}
        >
          {content}
        </div>
      )}
    </FloatingPortal>
  );
};

export default DropdownFilterContent;
